// Функция для нормализации пути
function normalizeSeoPath(path) {
  return path.endsWith('/') ? path : path + '/';
}

export { normalizeSeoPath };
